var map = {
	"./app-header.vue": 169
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;


//////////////////
// WEBPACK FOOTER
// ./src/components nonrecursive (.*)\w+\.(vue|js)$
// module id = 168
// module chunks = 16